import { spore } from '@/spore/runtime';
import { TOUCH_TEST_STEPS } from '@/spore/binaryTouch';

// Huge on-screen prompts for the guided touch test (lab button, C key, and the show's opening ritual).
export const TouchTestOverlay = ({ test, touching, hovering }) => {
  if (!test || !test.running) return null;
  const pct = test.stepMs ? 100 - Math.round((test.remainingMs / test.stepMs) * 100) : 0;
  const color = test.stepOn ? '#ffd166' : test.prompt && test.prompt.startsWith('HOVER') ? '#ff9ec7' : '#7f9cf5';
  return (
    <div data-testid="touch-test-overlay" className="pointer-events-none fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#050807]/85 backdrop-blur-md">
      <div className="label-eyebrow">CALIBRATION RITUAL · STEP {test.stepIndex + 1}/{TOUCH_TEST_STEPS.length}</div>
      <div data-testid="touch-test-prompt" className="font-display mt-6 text-7xl font-extrabold tracking-[0.08em] lg:text-9xl" style={{ color, textShadow: `0 0 60px ${color}` }}>{test.prompt}</div>
      <div className="mt-10 h-3 w-[min(800px,70vw)] border border-white/20"><div className="h-full" style={{ width: `${pct}%`, background: color }} /></div>
      <div data-testid="touch-test-live" className={`mt-6 text-lg tracking-[0.4em] ${touching ? 'text-[#ffd166]' : 'text-[var(--muted)]'}`}>{touching ? 'TOUCHING' : hovering ? 'HOVERING' : 'NOT TOUCHING'}</div>
    </div>
  );
};

export const runLabTouchTest = () => spore.startTouchTest();
